module.exports = {
    labels: require('./labels.json'),
    scoringStrategy: require('./scoring-strategy')
};



//////////////////
// WEBPACK FOOTER
// ./~/sentiment/languages/en/index.js
// module id = 1402
// module chunks = 0